<mat-button-toggle-group class="ml-[12px]" [(ngModel)]="selectedSob" #sob="matButtonToggleGroup">
  <mat-button-toggle
    [disabled]="isDisabled(sob)"
    *ngFor="let sob of sobs"
    [value]="sob.value"
    (change)="sobChange(sob)"
    ><b> {{ showAbbreviated ? sob.value : sob.name }}</b>
  </mat-button-toggle>
</mat-button-toggle-group>
